import React, { useState } from 'react';

function SearchFilter({ onFilter, data }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [sortBy, setSortBy] = useState('uploadDate');
  const [sortOrder, setSortOrder] = useState('desc');

  const handleSearch = () => {
    let filtered = [...data];

    // Search by file name or staff
    if (searchTerm) {
      filtered = filtered.filter(item =>
        item.fileName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.staffCount?.toString().includes(searchTerm)
      );
    }

    // Filter by date range
    if (dateRange.start) {
      filtered = filtered.filter(item =>
        new Date(item.uploadDate) >= new Date(dateRange.start)
      );
    }
    if (dateRange.end) {
      filtered = filtered.filter(item =>
        new Date(item.uploadDate) <= new Date(dateRange.end)
      );
    }

    // Sort
    filtered.sort((a, b) => {
      let aVal = a[sortBy];
      let bVal = b[sortBy];

      if (sortBy === 'uploadDate') {
        aVal = new Date(aVal).getTime();
        bVal = new Date(bVal).getTime();
      }

      if (sortOrder === 'asc') {
        return aVal > bVal ? 1 : -1;
      } else {
        return aVal < bVal ? 1 : -1;
      }
    });

    onFilter(filtered);
  };

  const handleReset = () => {
    setSearchTerm('');
    setDateRange({ start: '', end: '' });
    setSortBy('uploadDate');
    setSortOrder('desc');
    onFilter(data);
  };

  return (
    <div className="search-filter-container">
      <div className="search-filter-header">
        <div className="search-filter-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
          </svg>
        </div>
        <span>Filter & Search</span>
      </div>

      <div className="search-filter-row">
        <div className="filter-group">
          <label className="filter-label">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="m21 21-4.35-4.35"></path>
            </svg>
            Search
          </label>
          <div className="search-input-wrapper">
            <input
              type="text"
              placeholder="Search by file name..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="form-control search-input"
            />
          </div>
        </div>

        <div className="filter-group date-filter">
          <label className="filter-label">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            Date Range
          </label>
          <div className="date-inputs">
            <input
              type="date"
              value={dateRange.start}
              onChange={(e) => setDateRange({ ...dateRange, start: e.target.value })}
              className="form-control date-input"
            />
            <span className="date-separator">to</span>
            <input
              type="date"
              value={dateRange.end}
              onChange={(e) => setDateRange({ ...dateRange, end: e.target.value })}
              className="form-control date-input"
            />
          </div>
        </div>

        <div className="filter-group sort-filter">
          <label className="filter-label">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M11 5h10M11 9h7M11 13h4M3 17l3 3 3-3M6 18V4"></path>
            </svg>
            Sort By
          </label>
          <div className="sort-controls">
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="form-control sort-select"
            >
              <option value="uploadDate">Upload Date</option>
              <option value="fileName">File Name</option>
              <option value="staffCount">Staff Count</option>
              <option value="totalHours">Total Hours</option>
              <option value="totalOvertimeHours">Overtime Hours</option>
            </select>
            <button
              onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
              className={`sort-order-btn ${sortOrder}`}
              title={`Sort ${sortOrder === 'asc' ? 'Descending' : 'Ascending'}`}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                {sortOrder === 'asc' ? (
                  <path d="M12 19V5M5 12l7-7 7 7"></path>
                ) : (
                  <path d="M12 5v14M19 12l-7 7-7-7"></path>
                )}
              </svg>
            </button>
          </div>
        </div>

        <div className="filter-group filter-actions">
          <label className="filter-label">&nbsp;</label>
          <div className="action-buttons">
            <button onClick={handleSearch} className="btn btn-primary search-btn">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
              </svg>
              Search
            </button>
            <button onClick={handleReset} className="btn btn-secondary reset-btn">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                <path d="M3 3v5h5"></path>
              </svg>
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchFilter;
